import { createFileRoute } from '@tanstack/react-router'
import { BillingSettingsPage } from '../components/billing-settings'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/settings/billing')({
  head: () => noIndexRouteHead('settingsBilling', 'en'),
  component: BillingSettingsPage,
})
